module.exports = __webpack_public_path__ + "static/media/columbus_team.99a0076d.jpg";